/**
 * Wrapper around fetch that automatically injects the JWT Authorization header.
 * Use this instead of raw fetch() for all /api/* requests.
 */
export function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const token = localStorage.getItem('authToken');
  const existingHeaders = new Headers(init?.headers);
  if (token && !existingHeaders.has('Authorization')) {
    existingHeaders.set('Authorization', `Bearer ${token}`);
  }
  return fetch(input, { ...init, headers: existingHeaders });
}
